import React from 'react';

import SGColumnHeader from '../SGColumnHeader';

import SGConstants from '../../../utils/SGConstants';
import useSortableGrid from '../../../utils/UseSortableGrid';

import global from '../../GlobalStyle.module.css';

const GridRow = ({ staff }) => (
  <tr>
    <td>{staff.firstName || ''} {staff.lastName || ''}</td>
    <td>{staff.memberId || ''}</td>
    <td>{staff.isInGoodStanding === true ? 'Yes' : 'No'}</td>
  </tr>
);

const StaffRoleReportGridLarge = ({ data, isLoading, roleName = 'Staff' }) => {
  const {
    sortableGridState,
    onColumnClicked
  } = useSortableGrid(data);

  return (
    <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
      <thead>
        <tr>
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={`${roleName} Name`} columnField={'lastName'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Member Id'} columnField={'memberId'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Is in good standing?'} columnField={'isInGoodStanding'}
            sortType={SGConstants.SORT_TYPE_NUMERICAL} onColumnClicked={onColumnClicked} />
        </tr>
      </thead>
      <tbody>
        {isLoading === true
          ? <tr><td colSpan="3">Loading...</td></tr>
          : Array.isArray(sortableGridState.sortedGridData) && sortableGridState.sortedGridData.length > 0
            ? sortableGridState.sortedGridData.map((staff, i) => <GridRow key={i} staff={staff} />)
            : <tr><td colSpan="3">No {roleName}</td></tr>
        }
      </tbody>
    </table>
  );
};

export default StaffRoleReportGridLarge;